<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="users"
      :loading="loading"
      :server-items-length="total"
      @update:options="updateOptions"
      :options.sync="opts"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />

          <v-btn
            depressed
            color="accent"
            :to="{ name: 'ordem-medicao-formulario' }"
            v-if="perms.includes('ordemmedicao.criar_ordem_medicao')"
          >
            <v-icon class="mdi mdi-view-grid-plus-outline mr-2" />NOVO CADASTRO
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.id_cliente="{ item }">
        {{ item.cliente.nome }}
      </template>
      <template v-slot:item.data_emissao="{ item }">
        <span>{{ validaData(item.data_emissao) }}</span>
      </template>

      <template v-slot:item.situacao="{ item }">
        <span>{{ infoSituacao[item.situacao] }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu offset-y v-model="menu[item.id]">
          <template v-slot:activator="{ on }">
            <v-btn icon small text v-on="on" @click="$set(menu, item.id, true)">
              <v-icon title="Impressões" small>mdi-printer-settings</v-icon>
            </v-btn>
          </template>
          <v-card width="120">
            <v-row justify="space-around" class="pa-3">
              <v-btn icon small text @click="imprimir(item.id)">
                <v-icon
                  title="Imprimir Ordem"
                  class="mdi mdi-clipboard-list-outline"
                  small
                />
              </v-btn>
              <v-btn
                v-if="item.situacao == 'D'"
                icon
                small
                text
                @click="imprimirPreFatura(item.id)"
              >
                <v-icon
                  title="Imprimir medição de locação de guindastes"
                  class="mdi mdi-format-list-checks"
                  small
                />
              </v-btn>
              <v-menu
                offset-y
                v-if="
                  item.situacao != 'A' &&
                    item.situacao != 'B' &&
                    item.situacao != 'C' &&
                    item.situacao != 'D'
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon small text v-on="on">
                    <v-icon
                      title="Imprimir medição de locação de guindastes"
                      class="mdi mdi-format-list-checks"
                      small
                    />
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="imprimirPreFatura(item.id)">
                    <v-list-item-icon>
                      <v-icon>mdi-printer</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >Imprimir medição de locação de
                        guindastes</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <seletor-email
                    tipo-entidade="clientes"
                    :id-entidade="item.id_cliente"
                    tipo-padrao="financeiro"
                    @confirmar="enviarEmailMedicaoCliente(item, $event)"
                  >
                    <v-list-item link :disabled="enviandoEmailMedicao">
                      <v-list-item-icon>
                        <v-icon>mdi-send</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          enviandoEmailMedicao
                            ? "Enviando..."
                            : "Enviar medição de locação de guindastes p/ cliente"
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </seletor-email>
                </v-list>
              </v-menu>
              <v-btn
                v-if="
                  item.forma_faturamento != 'S' &&
                    (item.situacao == 'H' ||
                      item.situacao == 'I' ||
                      item.situacao == 'J')
                "
                icon
                small
                text
                @click="imprimirFatura(item.id)"
              >
                <v-icon
                  title="Imprimir fatura"
                  class="mdi mdi-playlist-check"
                  small
                />
              </v-btn>
              <v-menu
                offset-y
                v-if="
                  perms.includes('ordemmedicao.analise_dir_financeiro') &&
                    item.forma_faturamento != 'S' &&
                    item.situacao == 'K'
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon small text v-on="on">
                    <v-icon
                      title="Imprimir fatura"
                      class="mdi mdi-playlist-check"
                      small
                    />
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="imprimirFatura(item.id)">
                    <v-list-item-icon>
                      <v-icon>mdi-printer</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >Imprimir fatura cancelada</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <seletor-email
                    tipo-entidade="clientes"
                    :id-entidade="item.id_cliente"
                    tipo-padrao="financeiro"
                    @confirmar="enviarEmailFaturaCancelada(item, $event)"
                  >
                    <v-list-item link :disabled="enviandoEmailFaturaCancelada">
                      <v-list-item-icon>
                        <v-icon>mdi-send</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          enviandoEmailFaturaCancelada
                            ? "Enviando..."
                            : "Enviar fatura cancelada p/ cliente"
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </seletor-email>
                </v-list>
              </v-menu>
              <v-btn
                v-if="item.situacao == 'I' || item.situacao == 'J'"
                icon
                small
                @click="imprimirBoleto(item)"
              >
                <v-icon
                  title="Notas e Boletos"
                  class="mdi mdi-cash-usd-outline"
                  small
                />
              </v-btn>
            </v-row>
          </v-card>
        </v-menu>

        <v-menu offset-y v-model="menu2[item.id]">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              text
              v-on="on"
              @click="$set(menu2, item.id, true)"
            >
              <v-icon title="Itens" small>mdi-format-list-bulleted</v-icon>
            </v-btn>
          </template>
          <v-card width="100">
            <v-row justify="space-around" class="pa-3">
              <v-btn icon small text @click="itens(item.id)">
                <v-icon
                  title="Adicionar Equipamento"
                  class="mdi mdi-fire-truck"
                  small
                />
              </v-btn>
              <v-btn
                icon
                small
                text
                @click="
                  $store.commit('ordemMedicao/setProgramacaoPagamento', item)
                "
              >
                <v-icon
                  title="Programacao de pagamento"
                  class="mdi mdi-calendar-multiselect"
                  small
                />
              </v-btn>
              <lista-documentos-dialog
                title="Documentos"
                :id-proprietario="item.id"
                url-base="ordem"
              />
            </v-row>
          </v-card>
        </v-menu>

        <v-menu offset-y v-model="menu3[item.id]">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              text
              v-on="on"
              @click="$set(menu3, item.id, true)"
            >
              <v-icon title="Itens" small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card width="120">
            <v-row justify="space-around" class="pa-3">
              <v-btn
                v-if="
                  item.situacao == 'A' && item.cliente.enderecos.length <= 0
                "
                icon
                small
                @click="errorCliente()"
              >
                <v-icon
                  title="Análise dir. operacional"
                  class="mdi mdi-numeric-2-box-outline"
                  small
                />
              </v-btn>

              <dialog-confirm
                v-if="item.situacao == 'A' && item.cliente.enderecos.length > 0"
                titulo="1 - Digitação"
                texto="Confirma Envio da OM para 2 - Análise dir. operacional?"
                @confirmar="analise_dir_operacional(item)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Análise dir. operacional"
                    class="mdi mdi-numeric-2-box-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.analise_dir_operacional') &&
                    item.situacao == 'B'
                "
                titulo="2 - Análise dir. operacional"
                texto="Retornar para 1 - Digitação?"
                @confirmar="voltar_digitacao(item.id)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Digitação"
                    class="mdi mdi-numeric-1-box-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.analise_dir_operacional') &&
                    item.situacao == 'B'
                "
                titulo="2 - Análise dir. operacional"
                texto="Aprova e confirma envio da OM para análise do 3 - diretor financeiro?"
                @confirmar="aprov_dir_operacional(item)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Aprov. dir. financeiro"
                    class="mdi mdi-numeric-3-box-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>
              <dialog-confirm
                v-if="
                  (perms.includes('ordemmedicao.analise_dir_financeiro') &&
                    ['C', 'D'].indexOf(item.situacao) > -1) ||
                    (perms.includes('ordemmedicao.liberado_envio_cliente') &&
                      ['E', 'F'].indexOf(item.situacao) > -1)
                "
                :titulo="infoSituacao[item.situacao]"
                texto="Retornar para 2 - análise do dir. operacional?"
                @confirmar="analise_dir_operacional_voltar(item.id)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Análise dir. operacional"
                    class="mdi mdi-numeric-2-box-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.analise_dir_financeiro') &&
                    item.situacao == 'C'
                "
                titulo="3 - Análise do dir. financeiro"
                texto="Aprova OM e autorizo a criação da medição de locação?"
                @confirmar="analise_medicao_locacao(item.id)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Análise da medição de locação"
                    class="mdi mdi-numeric-4-box-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.analise_dir_financeiro') &&
                    item.situacao == 'D'
                "
                titulo="4 - Análise da Medição da Locação"
                texto="Confirma envio da medição de locação ao cliente?"
                @confirmar="liberar_envio_cliente(item.id)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Liberado para Envio ao Cliente"
                    class="mdi mdi-numeric-5-box-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.liberado_envio_cliente') &&
                    item.situacao == 'E'
                "
                titulo="5 - Liberado para envio ao cliente"
                texto="Confirma Envio da OM para aguardar aprovação do cliente?"
                @confirmar="aguardar_aprov_cliente(item.id)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Liberado para Aprovação do Cliente"
                    class="mdi mdi-numeric-6-box-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.liberado_envio_cliente') &&
                    item.situacao == 'F'
                "
                titulo="6 - Liberado Aprovação do Cliente"
                texto="Confirma Envio da OM para faturamento?"
                @confirmar="liberar_faturamento(item)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Liberado para Faturamento"
                    class="mdi mdi-numeric-7-box-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <v-btn
                v-if="
                  perms.includes('ordemmedicao.faturar') &&
                    item.situacao == 'G' &&
                    item.forma_faturamento != 'S'
                "
                icon
                small
                text
                @click="faturar(item.id)"
              >
                <v-icon
                  title="Faturar Ordem"
                  class="mdi mdi-currency-usd"
                  small
                />
              </v-btn>

              <v-btn
                v-if="
                  perms.includes('ordemmedicao.faturar') &&
                    item.situacao == 'I' &&
                    item.forma_faturamento != 'T'
                "
                icon
                small
                text
                @click="nfs(item.id)"
              >
                <v-icon
                  title="Cadastrar NFS-e"
                  class="mdi mdi-text-box-plus-outline"
                  small
                />
              </v-btn>

              <v-btn
                v-if="
                  perms.includes('ordemmedicao.faturar') &&
                    item.situacao == 'H' &&
                    item.forma_faturamento != 'S'
                "
                icon
                small
                text
                @click="faturar(item.id)"
              >
                <v-icon
                  title="Editar Fatura"
                  class="mdi mdi-file-edit-outline"
                  small
                />
              </v-btn>
              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.faturar') && item.situacao == 'H'
                "
                titulo="Pré-Fatura"
                texto="Finalizar OM e Faturar?"
                @confirmar="finalizar_fatura(item.id)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Finalizar Fatura"
                    class="mdi mdi-currency-usd"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.faturar') && item.situacao == 'I'
                "
                titulo="OM Faturada"
                texto="Confirma OM finalizada e enviada ao cliente?"
                @confirmar="encerrar_om(item.id)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Confirma OM finalizada e enviada ao cliente"
                    class="mdi mdi-checkbox-marked-outline"
                    small
                  />
                </v-btn>
              </dialog-confirm>

              <v-btn
                v-if="
                  (item.situacao == 'A' ||
                    (item.situacao == 'B' &&
                      perms.includes(
                        'ordemmedicao.analise_dir_operacional'
                      ))) &&
                    perms.includes('ordemmedicao.editar_ordem')
                "
                icon
                small
                text
                @click="editar(item.id)"
              >
                <v-icon title="Editar Ordem" class="mdi mdi-pencil" small />
              </v-btn>
              <dialog-confirm
                titulo="Copiar Ordem de Medição"
                texto="Deseja criar uma nova ordem de medição à partir desta?"
                @confirmar="copiar(item.id)"
              >
                <v-btn icon small text>
                  <v-icon title="Copiar Ordem" class="mdi mdi-transfer" small />
                </v-btn>
              </dialog-confirm>
              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.deletar_ordem') &&
                    (item.situacao == 'A' || item.situacao == 'B')
                "
                titulo="Deletar Ordem de Medição"
                texto="Confirma a exclusão?"
                @confirmar="deletar(item.id)"
              >
                <v-btn icon small text>
                  <v-icon title="Deletar Ordem" class="mdi mdi-delete" small />
                </v-btn>
              </dialog-confirm>

              <dialog-confirm
                v-if="
                  perms.includes('ordemmedicao.faturar') &&
                    perms.includes('ordemmedicao.analise_dir_financeiro') &&
                    (item.situacao == 'I' || item.situacao == 'J')
                "
                titulo="Cancelar Faturamento"
                texto="Confirma o cancelamento?"
                @confirmar="cancelar(item.id)"
              >
                <v-btn icon small text>
                  <v-icon
                    title="Cancelar Faturamento"
                    class="mdi mdi-cancel"
                    small
                  />
                </v-btn>
              </dialog-confirm>
            </v-row>
          </v-card>
        </v-menu>
      </template>
    </v-data-table>
    <seletor-boleto />
    <seletor-fatura />
    <programacao-pagamento @change="listar(opts)" />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import ListaDocumentosDialog from "../components/documentos/ListaDocumentosDialog";
import SeletorBoleto from "../components/boletos/SeletorBoleto";
import SeletorEmail from "../components/contatos/SeletorEmail";
import SeletorFatura from "../components/boletos/SeletorFatura";
import ProgramacaoPagamento from "../components/ordemmedicao/ProgramacaoPagamento";
import moment from "moment";
import number_format_lib from "../lib/number_format";
import { build } from "../lib/masks";

export default {
  components: {
    DatatableFilters,
    DialogConfirm,
    ListaDocumentosDialog,
    SeletorBoleto,
    SeletorEmail,
    SeletorFatura,
    ProgramacaoPagamento
  },
  data() {
    return {
      headers: [
        { text: "Código", value: "id" },
        { text: "Cliente", value: "id_cliente" },
        { text: "Local Referência", value: "local_referencia" },
        { text: "Emissão", value: "data_emissao" },
        { text: "Situação", value: "situacao" },

        { text: "Ações", value: "actions", sortable: false, align: "center" }
      ],
      filters: [
        {
          name: "id",
          label: "Código",
          type: "text",
          defaultValue: ""
        },
        {
          name: "situacao",
          label: "Situação",
          type: "select",
          options: [
            { value: "A", text: "1 - Digitação" },
            { value: "B", text: "2 - Análise dir. operacional" },
            { value: "C", text: "3 - Análise dir. financeiro" },
            { value: "D", text: "4 - Análise da Medição da Locação" },
            { value: "E", text: "5 - Liberado para envio ao cliente" },
            { value: "F", text: "6 - Liberado para Aprovação do Cliente" },
            { value: "G", text: "7 - Liberado para Faturamento" },
            { value: "H", text: "8 - Pré-Fatura" },
            { value: "I", text: "9 - Faturado/Cadastrar NFS-e" },
            { value: "J", text: "Finalizado e Enviado ao Cliente" },
            { value: "K", text: "Cancelado" }
          ]
        },
        {
          name: "id_cliente",
          label: "Cliente",
          type: "select",
          multiple: false,
          options: []
        }
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.ordens-medicao") || "{}"
      ),
      menu: {},
      menu2: {},
      menu3: {},
      preloader: false,
      dialogConfirm: false,
      infoSituacao: {
        A: "1 - Digitação",
        B: "2 - Análise dir. operacional",
        C: "3 - Análise dir. financeiro",
        D: "4 - Análise da Medição da Locação",
        E: "5 - Liberado para envio ao cliente",
        F: "6 - Liberado para Aprovação do Cliente",
        G: "7 - Liberado para Faturamento",
        H: "8 - Pré-Fatura",
        I: "9 - Faturado/Cadastrar NFS-e",
        J: "Finalizado e Enviado ao Cliente",
        K: "Cancelado"
      },
      enviandoEmailMedicao: false,
      enviandoEmailFaturaCancelada: false,
      loading: false,
      opts: {
        itemsPerPage: 10,
        page: 1,
        sortBy: ["id"],
        sortDesc: ["desc"]
      }
    };
  },
  computed: mapState({
    users: state => state.ordemMedicao.OrdemMedicao.dados,
    total: state => state.ordemMedicao.OrdemMedicao.total,
    perms: state => state.usuarios.usuarioAtivo.permissoes
  }),
  methods: {
    number_format(numero) {
      return number_format_lib(numero);
    },
    async deletar(id) {
      await this.$store.dispatch("ordemMedicao/deletar", { id });

      this.listar(this.opts);
    },
    async validaProgramacaoPagamento(om) {
      const totalOrdem = await this.$store.dispatch(
        "ordemMedicao/totalOrdem",
        om
      );
      let programado = 0;
      om.programacao_pagamento.map(prg => {
        programado += prg.valor;
        return prg;
      });
      const saldo = totalOrdem - programado;
      if (saldo != 0) {
        this.$store.commit("ui/setSnackbar", {
          text: "Você deve ajustar a programação de pagamento da OM",
          color: "warning"
        });
        this.$store.commit("ordemMedicao/setProgramacaoPagamento", om);
        return false;
      }
      return true;
    },
    async analise_dir_operacional(om) {
      const programacaoValida = await this.validaProgramacaoPagamento(om);
      if (!programacaoValida) {
        return;
      }
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: om.id,

        id_usuario_representante: this.$store.state.usuarios.usuarioAtivo.id,
        data_hora_validacao_representante: new Date(),

        situacao: "B"
      });

      this.listar(this.opts);
    },
    async analise_dir_operacional_voltar(id) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: id,
        situacao: "B"
      });

      this.listar(this.opts);
    },
    errorCliente() {
      this.$store.commit("ui/setSnackbar", {
        text: "Complete o cadastro do cliente!"
      });
    },
    async voltar_digitacao(id) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: id,
        situacao: "A"
      });

      this.listar(this.opts);
    },
    async aprov_dir_operacional(om) {
      const programacaoValida = await this.validaProgramacaoPagamento(om);
      if (!programacaoValida) {
        return;
      }
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: om.id,

        id_usuario_diretoria_operacional: this.$store.state.usuarios
          .usuarioAtivo.id,
        data_hora_diretoria_operacional: new Date(),

        situacao: "C"
      });

      this.listar(this.opts);
    },
    async cancelar(id) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: id,
        situacao: "K",
        id_usuario_cancelado: this.$store.state.usuarios.usuarioAtivo.id,
        data_hora_cancelado: new Date()
      });

      const id_ordem = id;
      const situacao = "CA";
      // ==== Alterar Faturas =================================
      const dados = await this.$store.dispatch(
        "ordemMedicao/buscarFaturaPorOrdem",
        {
          CarregarTudo: false,
          filtros: {
            id_ordem: parseInt(id_ordem)
          }
        }
      );

      if (dados.data.length > 0) {
        const dadosCR = await this.$store.dispatch(
          "contasReceber/retornaDados",
          {
            CarregarTudo: false,
            filtros: {
              origem: "FAT",
              id_origem: parseInt(dados.data[0].id)
            }
          }
        );

        for (let item of Array.from(dadosCR.dados)) {
          await this.$store.dispatch("contasReceber/gravar", {
            id: parseInt(item.id),
            situacao: situacao
          });
        }
      }
      // ===========================================================

      // ===== Alterar NFS =========================================
      const nota = await this.$store.dispatch(
        "ordemMedicao/buscarNotaPorOrdem",
        {
          filtros: { id_ordem: parseInt(id_ordem) }
        }
      );
      if (nota.data.length > 0) {
        const dadosCR = await this.$store.dispatch(
          "contasReceber/retornaDados",
          {
            CarregarTudo: false,
            filtros: {
              origem: "NFS",
              id_origem: parseInt(nota.data[0].id)
            }
          }
        );

        for (let item of Array.from(dadosCR.dados)) {
          await this.$store.dispatch("contasReceber/gravar", {
            id: parseInt(item.id),
            situacao: situacao
          });
        }
      }
      // ===============================================================

      await this.$store.dispatch("ordemMedicao/guardarDocumentos", id);

      this.listar(this.opts);
    },
    async analise_medicao_locacao(id) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: id,
        situacao: "D",

        id_usuario_diretoria_financeiro: this.$store.state.usuarios.usuarioAtivo
          .id,
        data_hora_diretoria_financeiro: new Date()
      });

      this.listar(this.opts);
    },
    async liberar_envio_cliente(id) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: id,
        situacao: "E",
        id_usuario_medicao_locacao: this.$store.state.usuarios.usuarioAtivo.id,
        data_hora_medicao_locacao: new Date()
      });

      this.listar(this.opts);
    },
    async aguardar_aprov_cliente(id) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: id,
        situacao: "F",
        id_usuario_envio_cliente: this.$store.state.usuarios.usuarioAtivo.id,
        data_hora_envio_cliente: new Date()
      });

      this.listar(this.opts);
    },
    async liberar_faturamento(om) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id_usuario_aprovado_cliente: this.$store.state.usuarios.usuarioAtivo.id,
        data_hora_aprovado_cliente: new Date(),
        id: om.id,
        situacao: om.forma_faturamento != "S" ? "G" : "I"
      });

      this.listar(this.opts);
    },
    async finalizar_fatura(id) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: id,
        situacao: "I",
        id_usuario_faturado: this.$store.state.usuarios.usuarioAtivo.id,
        data_hora_faturado: new Date()
      });

      const id_ordem = id;
      const situacao = "AB";
      // ==== Alterar Faturas =================================
      const dados = await this.$store.dispatch(
        "ordemMedicao/buscarFaturaPorOrdem",
        {
          CarregarTudo: false,
          filtros: {
            id_ordem: parseInt(id_ordem)
          }
        }
      );

      const dadosCR = await this.$store.dispatch("contasReceber/retornaDados", {
        CarregarTudo: false,
        filtros: {
          origem: "FAT",
          id_origem: parseInt(dados.data[0].id)
        }
      });

      for (let item of Array.from(dadosCR.dados)) {
        await this.$store.dispatch("contasReceber/gravar", {
          id: parseInt(item.id),
          situacao: situacao
        });
      }

      // ===========================================================

      this.listar(this.opts);
    },
    async encerrar_om(id) {
      await this.$store.dispatch("ordemMedicao/gravar", {
        id: id,
        situacao: "J",
        id_usuario_finalizado_enviado: this.$store.state.usuarios.usuarioAtivo
          .id,
        data_hora_finalizado_enviado: new Date()
      });

      // ===== Alterar NFS =========================================
      const nota = await this.$store.dispatch(
        "ordemMedicao/buscarNotaPorOrdem",
        {
          filtros: { id_ordem: parseInt(id) }
        }
      );
      if (nota.data.length > 0) {
        const dadosCR = await this.$store.dispatch(
          "contasReceber/retornaDados",
          {
            CarregarTudo: false,
            filtros: {
              origem: "NFS",
              id_origem: parseInt(nota.data[0].id)
            }
          }
        );

        for (let item of Array.from(dadosCR.dados)) {
          this.$store.dispatch("contasReceber/gravar", {
            id: parseInt(item.id),
            situacao: "AB"
          });
        }
      }
      // ===============================================================

      await this.$store.dispatch("ordemMedicao/guardarDocumentos", id);

      this.listar(this.opts);
    },
    editar(id) {
      this.$router.replace({
        path: "editar",
        name: "ordem-medicao-formulario-editar",
        params: { id }
      });
    },
    itens(id) {
      this.$router.replace({
        path: "item",
        name: "ordem-medicao-cadastro-item",
        params: { id }
      });
    },
    faturar(id) {
      this.$router.replace({
        path: "faturar",
        name: "ordem-medicao-faturar",
        params: { id }
      });
    },
    nfs(id) {
      this.$router.replace({
        path: "nfs",
        name: "ordem-medicao-nfs",
        params: { id }
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    async imprimirFatura(id) {
      try {
        const rel = await this.$store.dispatch("relatorio/gerarFatura", id);
        const url = window.URL.createObjectURL(
          new Blob([rel], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.revoke(url);
      } catch (e) {
        console.log(e);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível gerar a impressão da fatura"
        });
      }
    },
    async imprimirPreFatura(id) {
      try {
        const rel = await this.$store.dispatch("relatorio/gerarPreFatura", id);
        const url = window.URL.createObjectURL(
          new Blob([rel], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.revoke(url);
      } catch (e) {
        console.log(e);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível gerar a ordem de medição do cliente"
        });
      }
    },

    async imprimir(id) {
      try {
        const rel = await this.$store.dispatch("ordemMedicao/pdfOM", id);
        const url = window.URL.createObjectURL(
          new Blob([rel.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.revoke(url);
      } catch (err) {
        console.log(err);
      }
    },
    async listar(options) {
      this.loading = true;
      try {
        let ordenacao = options.sortBy[0];
        if (options.sortDesc[0]) {
          ordenacao += " desc";
        }
        if (ordenacao) {
          ordenacao += ", id desc";
        }

        await this.$store.dispatch("ordemMedicao/listar", {
          filtros: this.filtrosAtivos,
          pagina: options.page,
          por_pagina: options.itemsPerPage,
          ordenacao
        });
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    validaData(data) {
      if (data === "") return "-";
      return moment(data.substr(0, 10)).format("DD/MM/YYYY");
    },
    DataBR(dataSql) {
      if (!dataSql) return null;

      const [year, month, day] = dataSql.split("-");
      return `${day}/${month}/${year}`;
    },
    async imprimirBoleto(ordem) {
      this.$store.commit("boleto/setOrdemAtivaSeletor", ordem);
    },
    async imprimirEnviarFatura(ordem) {
      this.$store.commit("boleto/setFaturaAtivaSeletor", ordem);
    },
    revoke(url) {
      setTimeout(() => window.URL.revokeObjectURL(url), 3000);
    },
    async copiar(id_ordem) {
      let ordem = null;
      let ordemItens = null;
      try {
        const r1 = await this.$store.dispatch(
          "ordemMedicao/carregarOrdemMedicao",
          id_ordem
        );
        ordem = r1.data;

        const r2 = await this.$store.dispatch(
          "ordemMedicao/carregarItens",
          id_ordem
        );
        ordemItens = r2.data;
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          title: "Não foi possível recuperar os dados da OM base"
        });
        return;
      }

      try {
        const novaOrdem = await this.$store.dispatch("ordemMedicao/gravar", {
          id: "",
          id_cliente: ordem.id_cliente,
          local_referencia: ordem.local_referencia,

          forma_faturamento: ordem.forma_faturamento,
          percentual_fatura: ordem.percentual_fatura,
          percentual_nota_fiscal: ordem.percentual_nota_fiscal,
          percentual_equipamento: ordem.percentual_equipamento,
          percentual_mao_obra: ordem.percentual_mao_obra,
          percentual_comissao: ordem.percentual_comissao,
          faturamento_antecipado: ordem.faturamento_antecipado,
          sinistro: ordem.sinistro,
          seguro: ordem.seguro,
          cadastro_antecipado: ordem.cadastro_antecipado,
          data_vencimento_programada: ordem.data_vencimento_programada,
          id_usuario_emissao: this.$store.state.usuarios.usuarioAtivo.id,
          data_emissao: new Date(),
          situacao: "A",
          desconto: ordem.desconto
        });

        const promisesItem = ordemItens.map(i => {
          const novoItem = JSON.parse(JSON.stringify(i));
          novoItem.id_ordem = novaOrdem.id;
          novoItem.id_ordem_item = "";
          delete novoItem.item;
          delete novoItem.id;
          delete novoItem.unidade_terceiro;
          delete novoItem.unidade_cobranca;
          delete novoItem.unidade_bv;
          delete novoItem.equipamento_usado;
          delete novoItem.equipamento_medicao;
          return this.$store.dispatch("ordemMedicao/gravarItem", novoItem);
        });
        await Promise.all(promisesItem);
        this.$router.replace({
          path: "editar",
          name: "ordem-medicao-formulario-editar",
          params: { id: novaOrdem.id }
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível criar a nova ordem"
        });
      }
    },
    async enviarEmailMedicaoCliente(om, emails) {
      this.enviandoEmailMedicao = true;
      try {
        const payload = new FormData();
        const rel = await this.$store.dispatch(
          "relatorio/gerarPreFatura",
          om.id
        );
        const arquivo = new File([rel], "medicao_locacao.pdf", {
          type: "application/pdf"
        });
        payload.append("arquivos", arquivo);

        payload.append("emails", emails.join(","));

        const ordemItens = await this.$store.dispatch(
          "ordemMedicao/carregarItens",
          om.id
        );
        const periodoInicio = ordemItens.data[0].data_medicao;
        const periodoFim =
          ordemItens.data[ordemItens.data.length - 1].data_medicao;

        let dataProgramada = "";
        if (om.data_vencimento_programada) {
          dataProgramada = this.validaData(om.data_vencimento_programada);
        } else {
          dataProgramada = om.programacao_pagamento
            .map(prg => {
              const data = moment(prg.data).format("DD/MM/YYYY");
              const valor = build.money(prg.valor);
              const antecipado = prg.antecipado ? " (antecipado)" : "";
              return `${data}${antecipado} - ${valor}`;
            })
            .join("; ");
        }

        payload.append("id_ordem", om.id);
        payload.append("dataProgramada", dataProgramada);
        payload.append("periodoInicio", this.validaData(periodoInicio));
        payload.append("periodoFim", this.validaData(periodoFim));
        payload.append("situacao", om.situacao);
        payload.append("observacaoCliente", om.observacao_cliente);

        await this.$store.dispatch("email/medicaoCliente", {
          payload
        });
        this.dialog = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Email enviado com sucesso",
          color: "success"
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível enviar o email ao cliente"
        });
      }
      this.enviandoEmailMedicao = false;
    },
    async enviarEmailFaturaCancelada(om, emails) {
      this.enviandoEmailFaturaCancelada = true;
      try {
        const payload = new FormData();
        const rel = await this.$store.dispatch("relatorio/gerarFatura", om.id);
        const arquivo = new File([rel], "fatura_cancelada.pdf", {
          type: "application/pdf"
        });
        payload.append("arquivos", arquivo);

        payload.append("emails", emails.join(","));

        const response = await this.$store.dispatch(
          "ordemMedicao/buscarFaturaPorOrdem",
          {
            CarregarContasReceber: true,
            filtros: { id_ordem: om.id }
          }
        );
        const fatura = response.data.pop();

        payload.append("nomeCliente", om.cliente.nome);
        payload.append("numeroFatura", fatura.numero);

        await this.$store.dispatch("email/faturaCancelada", {
          payload
        });
        this.dialog = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Email enviado com sucesso",
          color: "success"
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível enviar o email ao cliente"
        });
      }
      this.enviandoEmailFaturaCancelada = false;
    },
    updateOptions(opts) {
      this.listar(opts);
    }
  },

  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.ordens-medicao", JSON.stringify(val));
      this.opts.page = 1;
      this.listar(this.opts);
    }
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "OM - Ordem de Medição"
    });

    this.$store.dispatch("cliente/listar", {}).then(formas => {
      this.filters.find(
        f => f.name === "id_cliente"
      ).options = formas.data.clientes.map(f => ({
        text: `${f.nome} (${f.nome_vendedor}) - ${f.razao_social}`,
        value: f.id
      }));
    });
  }
};
</script>
